var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocked = function SvgLocked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M16.39 9.001h-.803v-2.25a4.86 4.86 0 0 0-1.547-3.41 5 5 0 0 0-3.541-1.34 5 5 0 0 0-3.543 1.34 4.86 4.86 0 0 0-1.549 3.41V9h-.8a1.58 1.58 0 0 0-1.118.423A1.53 1.53 0 0 0 3 10.5v6c.011.408.187.796.489 1.077.3.281.703.433 1.119.422h11.784c.416.011.818-.141 1.12-.422.3-.282.476-.669.488-1.078V10.5a1.53 1.53 0 0 0-.489-1.076A1.58 1.58 0 0 0 16.392 9zm-3.482 0H8.086v-2.25a2.36 2.36 0 0 1 .752-1.595 2.44 2.44 0 0 1 1.66-.65c.617 0 1.21.232 1.659.65.448.417.717.988.752 1.594z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocked);
export default ForwardRef;